<ng-container *ngIf="isLoading"> Loading... </ng-container>
<ng-container *ngIf="!isLoading">
  <ng-container *ngIf="isSubscribed; else notSubscribed">
    <ng-content select="[subscribedTemplate]"></ng-content>
  </ng-container>
  <ng-template #notSubscribed>
    <ng-content select="[notSubscribedTemplate]"></ng-content>
  </ng-template>
</ng-container>
